import { render, staticRenderFns } from "./HomepageSupplier.vue?vue&type=template&id=062e67f4&scoped=true&"
import script from "./HomepageSupplier.vue?vue&type=script&lang=js&"
export * from "./HomepageSupplier.vue?vue&type=script&lang=js&"
import style0 from "./HomepageSupplier.vue?vue&type=style&index=0&id=062e67f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "062e67f4",
  null
  
)

export default component.exports